import styled from 'styled-components';

export const Container = styled.div`
  padding: 16px 0;
`;

export const WrapperGrid = styled.div`
  padding: 16px 0;
`;
